import axiosVerbose from './axios/axiosVerbose'

export const getUserProfileRequest = token => {
  return axiosVerbose
    .get('/shopfront_api/user', {
      headers: {
        Authorization: `Bearer ${token}` // eslint-disable-line
      }
    })
    .then(res => res.data)
}

export const getGuestCartRequest = () => {
  return axiosVerbose.get('/shopfront_api/cart')
}

export const addItemToUserCartRequest = (token, data) => {
  return axiosVerbose
    .post('/shopfront_api/user/cart/entry', data, {
      headers: {
        Authorization: `Bearer ${token}` // eslint-disable-line
      }
    })
    .then(res => res.data)
}

export const editUserCartEntryRequest = (token, entryID, data) => {
  return axiosVerbose
    .put(`/shopfront_api/user/cart/entry/${entryID}`, data, {
      headers: {
        Authorization: `Bearer ${token}` // eslint-disable-line
      }
    })
    .then(res => res.data)
}

export const createUserCartRequest = token =>
  axiosVerbose
    .post(
      '/shopfront_api/user/cart/',
      {},
      {
        headers: {
          Authorization: `Bearer ${token}` // eslint-disable-line
        }
      }
    )
    .then(res => res.data)

export const createGuestCartRequest = () =>
  axiosVerbose.post('/shopfront_api/cart/', {}).then(res => res.data)

export const addItemToGuestCartRequest = data => {
  return axiosVerbose
    .post(`/shopfront_api/cart/entry`, data)
    .then(res => res.data)
}

export const editGuestCartEntryRequest = (entryID, data) => {
  return axiosVerbose
    .put(`/shopfront_api/cart/entry/${entryID}`, data)
    .then(res => res.data)
}

export const getBookmarksForItemsRequest = (token, itemIds) => {
  return axiosVerbose
    .get(
      `/shopfront_api/user/bookmarks_for_items?item_ids=${itemIds.join(',')}`,
      {
        headers: {
          Authorization: `Bearer ${token}` // eslint-disable-line
        }
      }
    )
    .then(res => res.data)
}

export const deleteBookmarkRequest = (token, id) => {
  return axiosVerbose
    .delete(`/shopfront_api/user/bookmark/${id}`, {
      headers: {
        Authorization: `Bearer ${token}` // eslint-disable-line
      }
    })
    .then(res => res.data)
}

export const createBookmarkRequest = (token, collectionId, itemId) => {
  return axiosVerbose
    .post(
      `/shopfront_api/user/collection/${collectionId}/bookmark`,
      {
        item_id: itemId
      },
      {
        headers: {
          Authorization: `Bearer ${token}` // eslint-disable-line
        }
      }
    )
    .then(res => res.data)
}

export const createCollectionRequest = (
  token,
  { name, isPublic, description, specialRole }
) => {
  return axiosVerbose
    .post(
      '/shopfront_api/user/collection',
      {
        name,
        public: isPublic,
        description,
        specialRole
      },
      {
        headers: {
          Authorization: `Bearer ${token}` // eslint-disable-line
        }
      }
    )
    .then(res => res.data)
}

/**
 * Converts a User Api Response to a user object,
 * a list of their collections with bookmarks nested,
 * @param  {Object} the api user response
 * @return {Object} a object with the users info, collections/bookmarks and favorites collection ID
 */
export const formatUserResponse = userResponse => {
  try {
    let user = { ...userResponse }

    delete user.collections
    delete user.cart
    delete user.misc

    const collections = userResponse.collections
    let newCollections = {}

    if (collections) {
      newCollections = collections.reduce((prev, collection) => {
        prev[collection.id] = collection
        prev[collection.id].bookmarks = {}
        return prev
      }, {})
    }

    return {
      profile: user,
      collections: newCollections,
      cart: userResponse.cart,
      misc: userResponse.misc
    }
  } catch (e) {
    // eslint-disable-next-line
    console.log('format user response error', e)
  }
}



// WEBPACK FOOTER //
// ./common/utils/user.js